/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';

export const genreSentimentSchema = z.object({
  genre: z.string(),
  loved: z.number(),
  liked: z.number(),
  disliked: z.number(),
  score: z.number(),
});

export interface IGenreSentiment {
  genre: string;
  loved: number;
  liked: number;
  disliked: number;
  score: number;
}
